import { createCpmsBoNetworkSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-network.slice';

import { cpmsBoNetworkApi } from './cpms-bo-network.service';

export const cpmsBoNetworkSlice = createCpmsBoNetworkSlice({
  cpmsBoNetworkApi,
});
